// Where the first street arrival lands — the recorded walk-in spot
// (2026-07-23, ?cam=edit "copy spawn"), standing at z≈25.5 looking −z across
// the block. PlanetScene flies the camera here; the height is its own EYE.
//
// Shared because the RESIDENTS need it too: until the player has actually
// arrived, the camera is hanging over the city on the landing page, a hundred
// units from anyone, and bodies stream by distance to the camera. Measured from
// there, the people you are about to land among only started loading once the
// fly-in was already under way — decode, skinning setup and texture upload
// landing inside the one animation that must not stutter. Khari's rule
// (2026-08-02) is the opposite: load behind the gate, fly in over a finished
// city. Streaming therefore also measures from HERE until arrival.
export const STREET_SPAWN = { pos: [0.18, 25.53], look: [0.21, 1.33, 23.65] };
